// Module
var code = "<div id=\"errorModal\"> <div class=\"modal-header\" ng-if=\"title\"> <h4 class=\"modal-title\">{{title}}</h4> </div> <div class=\"modal-body\" ng-bind-html=\"msg\"></div> <div class=\"modal-footer\"> <button type=\"button\" class=\"btn btn-default btn-primary\" ng-click=\"close()\">Ok </button> </div> </div> ";
// Exports
export default code;